import { useEffect } from 'react';

export function useOutsideClick({ ref, handler, activate = true, ignoreRef = null, ignoreId = null }) {
  useEffect(() => {
    if (!activate || !handler) return;
    const listener = (event) => {
      const target = event.target;

      const isIgnored =
        !ref.current ||
        ref.current.contains(target) ||
        (ignoreRef?.current && ignoreRef?.current.isEqualNode(target)) ||
        (Array.isArray(ignoreId)
          ? ignoreId.some((id) => target.closest(`#${id}`))
          : typeof ignoreId === 'string' && target.closest(`#${ignoreId}`));

      if (isIgnored) return;

      handler && handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, activate]);
}
